(function( $ ) {

	$( document ).ready( () => {

		if ( ! document.querySelector('.single-post') ) {
			return
		}

		$( document ).on( 'click', '.collapsable-categories__expand', function() {
			$( this ).parent().addClass('active')
		} )

	} )

})( jQuery );


// WEBPACK FOOTER //
// ./assets/js/layout/single-story.js